import * as __WEBPACK_EXTERNAL_MODULE__TabsContent_js_803adaa0__ from "./TabsContent.js";
import * as __WEBPACK_EXTERNAL_MODULE__TabsList_js_a667dbce__ from "./TabsList.js";
import * as __WEBPACK_EXTERNAL_MODULE__TabsRoot_js_8ff7dab4__ from "./TabsRoot.js";
import * as __WEBPACK_EXTERNAL_MODULE__TabsTrigger_js_c9ff65af__ from "./TabsTrigger.js";
const Tabs = {
    Root: __WEBPACK_EXTERNAL_MODULE__TabsRoot_js_8ff7dab4__.TabsRoot,
    List: __WEBPACK_EXTERNAL_MODULE__TabsList_js_a667dbce__.TabsList,
    Trigger: __WEBPACK_EXTERNAL_MODULE__TabsTrigger_js_c9ff65af__.TabsTrigger,
    Content: __WEBPACK_EXTERNAL_MODULE__TabsContent_js_803adaa0__.TabsContent
};
const Tabs_rslib_entry_ = Tabs;
export { Tabs_rslib_entry_ as default };

//# sourceMappingURL=index.js.map